export const COUNTRY_CONFIG = {
  france: { locale: "fr", currency: "EUR", displayCurrency: "EUR" },
  poland: { locale: "pl", currency: "PLN", displayCurrency: "PLN" },
  germany: { locale: "de", currency: "EUR", displayCurrency: "EUR" },
};
